import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

class DraftsTable extends React.Component {
  constructor() {
    super()

    this.state = {
      draftModels: [],
    }

    this.fetchData = this.fetchData.bind(this)
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    return axios.get(`/api/internal/items/drafts?current_model_id=${this.props.modelId}`, {})
      .then((response) => this.onFetchSuccess(response))
      .catch((xhr) => { App.events.publish('app:notification:flash:error', xhr.response.statusText) })
  }

  onFetchSuccess(response) {
    return this.setState({
      draftModels: response.data.data,
    })
  }

  render() {
    return (
      <table className="table-with-borders table-with-borders--centered drafts-list">
        <colgroup>
          <col style={{ width: '20%' }} />
          <col style={{ width: '44%' }} />
          <col style={{ width: '18%' }} />
          <col style={{ width: '18%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>Image</th>
            <th>Title</th>
            <th>Date created</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {this.state.draftModels.map((item) => (
            <tr key={item.id} onClick={() => this.props.chooseModel(item.id)}>
              <td><img src={item.attributes.image.thumbUrl} /></td>
              <td className="product-text__title">
                {item.attributes.title ? item.attributes.title : <span className="no-title">Title is not set</span>}
              </td>
              <td>{item.attributes.createdAt}</td>
              <td>{item.attributes.itemType}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

DraftsTable.propTypes = {
  modelId: PropTypes.string.isRequired,
  chooseModel: PropTypes.func.isRequired,
}

export default DraftsTable
